import Home from "./home"
import TrustBar from "../components/TrustBar"
import Chaine from "./chaine"
import Sports from "./sports"
import Pricing from "./pricing"
import How from "./how"
import Why from "./why"
import Device from "./device"
import Faq from "./faq"
import Review from "./review"
import FinalCTA from "../components/FinalCTA"
import Seo from "../components/seo/Seo"

export default function All(){
    return(
        <>
            <Seo
                title="TiviOne – IPTV Nederland & België | Alle zenders in 4K zonder buffering"
                description="TiviOne is hét IPTV-abonnement voor Nederland en België, op de officiële TiviOne-server. Alle NL & Vlaamse zenders, Eredivisie en Champions League, 79.000+ kanalen en 249.000+ films en series in HD/4K zonder buffering. Directe activering."
                path="/"
            />
            <Home/>
            <TrustBar/>
            <Pricing/>
            <Chaine/>
            <Sports/>
            <How/>
            <Why/>
            <Device/>
            <Faq/>
            <Review/>
            <FinalCTA/>
        </>
    )
}